import dayjs from 'dayjs';

export const formatMediaDuration = (duration: number) => {
    return duration ? `, ${dayjs.duration(duration * 1000).format('HH:mm:ss')}s` : '';
};
